import { render, staticRenderFns } from "./bnkjhz.vue?vue&type=template&id=69e6fe82&scoped=true&"
import script from "./bnkjhz.vue?vue&type=script&lang=js&"
export * from "./bnkjhz.vue?vue&type=script&lang=js&"
import style0 from "./bnkjhz.vue?vue&type=style&index=0&id=69e6fe82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e6fe82",
  null
  
)

export default component.exports